export default __webpack_public_path__ + "static/media/plus.1fa1ca63.svg";